import {AxiosInstance} from 'axios'
import _Vue from 'vue'
import BanzaiSyncpointsService from '@/services/banzai-syncpoints.service'

export default {
  install(
    Vue: typeof _Vue,
    {http}: { http: AxiosInstance }) {
    Vue.prototype.$banzaiSyncPoints = new BanzaiSyncpointsService(http)
  },
}

declare module 'vue/types/vue' {
  interface Vue {
    $banzaiSyncPoints: BanzaiSyncpointsService;
  }
}
